
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/brain-cli",
      function () {
        return require("private-next-pages/projects/brain-cli.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/brain-cli"])
      });
    }
  